import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {UserService} from "../services/user.service";

@Directive({
    selector: '[appShowIfOrganizationHasFeature]',
    standalone: false
})
export class ShowIfOrganizationHasFeatureDirective {
  private featureName: string = null;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private userService: UserService,
  ) {
  }

  @Input()
  set appShowIfOrganizationHasFeature(name: string) {
    this.featureName = name
    this.updateView();
  }

  private updateView() {
    if (!this.featureName) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      return;
    }

    const customs = this.userService?.currentOrganization?.customs;
    if (!customs) {
      this.viewContainer.clear();
      return;
    }

    const inFeatures = customs.features && this.featureName in customs.features;
    const topLevelVal = customs[this.featureName];

    let show: boolean;
    if (inFeatures) {
      show = customs.features[this.featureName] === true;
    } else if (this.featureName in customs) {
      show = topLevelVal !== false;
    } else {
      show = false;
    }

    if (show) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
